import React from 'react';

import Button from '@asteria/component-core/button';
import { Text, Title } from '@asteria/component-core/typography';

import { useTranslate } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import Header from '../../components/header';
import SelectScenarioModal from '../../modals/scenario/select';

const WelcomePage = (props) => {
	const { className, onSubmit } = props;
	const [showModal, setShowModal] = React.useState(false);
	const { t } = useTranslate();

	const onSelect = React.useCallback(
		(event, data) => {
			if (event === 'scenario:selected') {
				setShowModal(false);
			}

			onSubmit?.(event, data);
		},
		[onSubmit],
	);

	return (
		<div
			className={cn(
				'asteria-component__forecaster-page',
				'asteria--type-home',
				className,
			)}
		>
			<Header />
			<SelectScenarioModal
				open={showModal}
				onSubmit={onSelect}
				onClose={() => setShowModal(false)}
			/>
			<div className="flex flex-col items-center justify-center">
				<div className="flex flex-col items-center gap-8 text-center">
					{/* Main Heading */}
					<Title size="page-title" className="font-bold">
						{t('forecaster.welcome.title')}
					</Title>

					{/* Description Text */}
					<Text size="lg" className="text-content-text-normal">
						{t('forecaster.welcome.description')}
					</Text>

					{/* Placeholder Image Area */}
					<div className="w-80 h-80 rounded-lg flex items-center justify-center">
						<img
							src={`/images/forecaster/welcome.png`}
							alt="Forecaster Welcome"
							width={320}
							height={320}
						/>
					</div>

					{/* New Forecast Button */}
					<Button
						variant="primary"
						size="lg"
						label={t('forecaster.welcome.button.new')}
						className="mt-4"
						onClick={() => setShowModal(true)}
					/>

					{/* Help Link */}
					<Button
						variant="link"
						label={t('forecaster.welcome.link.help')}
						className="mt-8 underline"
					/>
				</div>
			</div>
		</div>
	);
};

export default WelcomePage;
